import React from 'react';
import { motion } from 'framer-motion';
import ThumbnailCard from './ThumbnailCard';

const ThumbnailGrid = ({ thumbnails }) => {
  return (
    <div className="space-y-6">
      <div className="text-center">
        <h3 className="text-2xl font-bold text-gray-800 mb-2">
          Available Thumbnails
        </h3>
        <p className="text-gray-600">
          Found {thumbnails.length} thumbnail{thumbnails.length !== 1 ? 's' : ''}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {thumbnails.map((thumbnail, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
          >
            <ThumbnailCard thumbnail={thumbnail} />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ThumbnailGrid;